export const normalizePrefillFrequency = (frequency) => {
  if (!frequency) {
    return null;
  }

  return frequency.toLowerCase().split("ly")[0];
};
